export default "/images/info-circle.svg?9ddf607765481f3cb9078653fba9b1ad";